import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import React from "react";

// Inicialización de Sentry
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      // Opciones adicionales de configuración para Session Replay
      maskAllText: false, // Enmascara el texto visible
      blockAllMedia: false, // Bloquea el contenido multimedia visible
    }),
  ],
  tracesSampleRate: 1.0, // Muestra del 100% para las trazas de rendimiento
  replaysSessionSampleRate: 0.1, // Muestra del 10% de las sesiones para Replay
  replaysOnErrorSampleRate: 1.0, // Captura Replay cuando ocurre un error
  debug: import.meta.env.VITE_SENTRY_DEBUG_MODE || false, // Puedes cambiarlo a true para habilitar logs de depuración
});

export default Sentry;
